import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const AdditionalInfoHeaderStyled = styled.div`
  display: flex;
  justify-content: center;
  margin: 5rem auto;
  text-align: start;
`;

export const FileUploadWrapperStyled = styled.div`
  margin-bottom: 8rem;
  text-align: left;
`;

export const SubtitleStyled = styled.p`
  padding-bottom: 2rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const SponsorFieldStyled = styled.div`
  margin-right: 4rem;
`;

export const ValidationErrorMessageStyled = styled.p`
  color: ${colors.red[600]};
  ${typography.regular[16]}
  margin: 2rem 0 0;
`;
